import { __extends } from "tslib";
import { Entity } from './entity';
/**
 * 定义为abstract的，domain层面的所有聚合根都要继承这个基类
 */
var Aggregate = /** @class */ (function (_super) {
    __extends(Aggregate, _super);
    function Aggregate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * 聚合根实现者要维护aggregateVersion 和 aggregateIsDeleted
         */
        _this.aggregateVersion = 0;
        _this.aggregateIsDeleted = false;
        return _this;
    }
    Aggregate.prototype.version = function () {
        return this.aggregateVersion;
    };
    Aggregate.prototype.isDeleted = function () {
        return this.aggregateIsDeleted;
    };
    return Aggregate;
}(Entity));
export { Aggregate };
